type ShadowToken = {
  x: number;
  y: number;
  shadow: string;
  blur: number;
  spread: number;
};

export const toBoxShadow = (token: ShadowToken): string =>
  `${token.x}px ${token.y}px ${token.blur}px ${token.spread}px ${token.shadow}`;
